import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import {
  FilterPeriod,
  OrderCountryDataResponse,
  OrderTickingData,
} from './types';

export interface OrderStatsFilters {
  period?: FilterPeriod | null;
  createdFrom: Date | null;
  createdTo: Date | null;
  orderTypes: string[] | null;
  merchantIds: string[] | null;
}

export const getTickingOrderData = async ({
  filters,
}: {
  filters?: OrderStatsFilters;
}) => {
  const data = await fetchAPI<OrderTickingData>(`v1/orders/stats/ticking`, {
    method: 'POST',
    body: {
      filters: {
        ...filters,
        createdFrom: filters?.createdFrom
          ? filters.createdFrom.toISOString()
          : null,
        createdTo: filters?.createdTo ? filters.createdTo.toISOString() : null,
      },
    },
  });

  return data;
};

export const getOrderCountryData = async ({
  filters,
}: {
  filters?: OrderStatsFilters;
}) => {
  const data = await fetchAPI<OrderCountryDataResponse>(
    `v1/orders/stats/country-data`,
    {
      method: 'POST',
      body: {
        filters: {
          ...filters,
          createdFrom: filters?.createdFrom
            ? filters.createdFrom.toISOString()
            : null,
          createdTo: filters?.createdTo
            ? filters.createdTo.toISOString()
            : null,
        },
      },
    }
  );

  return data;
};
